<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
// import Select from "@/components/c-select";
// import ServiceRow from "../../../../components/manage-sevice-row";

import { propertyUtility } from "../../../../services/managements/propertyservice/propertyutility.service";
import { propertyService } from "../../../../services/managements/propertyservice/property.service";
// import { projectService } from "../../../../services/managements/propertyservice/property.service";
import { service } from "../../../../services/managements/services/service";
import { propertyServiceService } from "../../../../services/managements/propertyservice/propertyservice.service";
import { utilityService } from "../../../../services/managements/utilities/utility.service";

// import { servicehelpers } from "../../../../services/servicehelpers";


import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Utility Rcord Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    // Select,
    // ServiceRow
  },
  data() {
    return {
      dropdownSelection: {},
   
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Utility Record",
      breadCrumb: {},
      projectData: {},
      propertyData: {},
      serviceData: {},
      modifiedServiceData: {},
      propertyServiceData: {},
      discountTypeData: {},
      utilityData: {},
      // discountText: '',

      dataProjectId: 0,
      dataPropertyId: 0,
      dataWatter: 0,
      dataWatterPrice: 0,
      dataWatterAmount: 0,
      dataElectrict: 0,
      dataElectrictPrice: 0,
      dataElectrictAmount: 0,
      dataLastWatter: 0,
      dataLastElectrict: 0,
      // dataTotalPrice: 0,
      // dataDiscount: 0,
      // dataDiscountType: 0,
      dataInvoiceDate: this.$moment().clone().format('YYYY-MM-DD'),
      dataInvoiceExpiredDate: this.$moment().add(10, 'days').format('YYYY-MM-DD'),
      dataUtilityStartDate: '',
      dataUtilityEndDate: ''
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }


    // this.loadingDiscountTypeData();

  },
 
  methods: {
    loadingData: function(id) {
      this.fetchingStats = true;
      propertyService.getOne(id)
        .then(response => {
          if(id != 0){
            // console.log(response)
            this.propertyData = response.data;
            this.dataProjectId = response.data.project_id;
            this.dataPropertyId = response.data.id;
            this.dataLastWatter = response.data.last_watter_record;
            this.dataLastElectrict = response.data.last_electrict_record;
           
          }
          this.loadServiceData(id)
          this.loadUitlityByProjectId(this.dataProjectId);
          this.projectData = {data: response.setting.projects}
          this.dataUtilityStartDate = this.getUtilityDate();
          this.dataUtilityEndDate = this.getUtilityDate(true)

        });

    },

    loadServiceData:  function(id, param = '?page=0') {
      service.getList(param)
        .then(response => {
          let currentData = response.data;
          this.serviceData = currentData;
          this.loadServiceByPropertyId(id);
        });
       
    },

    loadUitlityByProjectId: function(id, param = ''){
      param = `?page=0&clause={"clause":[{"conjuction":"and","mg_utilities.project_id":{"value":${id}}}]}`;
      utilityService.getList(param)
        .then(response => {
          this.utilityData = response.data;
          this.dataWatterPrice = this.utilityData[0].price;
          this.dataElectrictPrice = this.utilityData[1].price;
        });
    },

    loadServiceByPropertyId: function(id, param = '?page=0'){
      param = `?page=0&clause={"clause":[{"conjuction":"and","mg_property_services.property_id":{"value":${id}}}]}`;
      propertyServiceService.getList(param)
        .then(response => {
          if(id != 0){
            this.propertyServiceData = response.data;
            let selected_services = this.propertyServiceData.map((item) => item.service_id);
            if(this.serviceData){
              this.serviceData.map((item, i)=>{
                let check = selected_services.includes(item.id);
                this.serviceData[i].check = check;
                this.serviceData[i].quantity = check ? (this.propertyServiceData[i].quantity) : 1;
                this.serviceData[i].service_for = this.propertyServiceData[i].service_for;
                this.modifiedServiceData = this.serviceData;
              });
              this.getBillDate();
            }

          }
        });

        // this.loadServiceData();
        // console.log(this.serviceData);
    },

    getBillDate: function(){
      this.propertyServiceData.map((item, i)=>{
        this.serviceData.map((s, k)=>{
          if(item.service_id == s.id){
            this.serviceData[k].monthBilling = this.propertyServiceData[i].billing_cycle_date;
          }
        });
      });
    },

    getUtilityDate(end_date = false){
      let day = this.propertyData.monthly_billing_date;
      let month = !end_date ? this.$moment().format('MM') : this.$moment().add(1, 'M').format('MM');
      let year = this.$moment().format('YYYY');
      // console.log(`${year}-${month}-${day}`);
      return  `${year}-${month}-${day}`;
    },

    // loadingDiscountTypeData: function() {
    //   servicehelpers.getDiscountTypeData().then(response => {
    //     this.discountTypeData = response;
    //   });
    // },
    // discountTypeChanged: function(event) {

    //   const discountType = this.discountTypeData.data.find(obj => {
    //     return obj.id === event
    //   });

    //   this.discountText = discountType == null ? "" : discountType.name;

    //   // console.log(this.dataDiscountText);
    //   this.changeTotalPrice();
    // }, 

    // changeTotalPrice: function() {
    //   if(this.dataDiscountType == 2) {
    //     this.dataSalePrice = this.dataAmount - this.dataDiscount;
    //   } else {
    //     this.dataSalePrice = this.dataAmount - (this.dataDiscount * this.dataAmount / 100);
    //   }
    // },
    

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "manage-property"
          });

        }
      });
    
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;

      if(this.dataElectrict < this.dataLastElectrict || this.dataWatter < this.dataLastWatter){
        return false;
      }

      let list = [];
      Object.keys(this.$refs).map(el => {
        // console.log(this.$refs[el]);
        if('getItem' in this.$refs[el][0]) {
          let partner = (this.$refs[el][0]).getItem();
          if(partner != null && partner.check) {
            list.push(partner);
          }
        }
      });
      let data_watter = {
          id: 'w1',
          quantity: this.dataWatter - this.dataLastWatter,
          price: this.dataWatterPrice,
          amount: this.dataWatterAmount,
          check: false,
          name: "ទឹក",
          name_en: "Water",
          monthBilling: 0,
          old_record: this.dataLastWatter,
          new_record: this.dataWatter,
          service_for: (this.propertyData.is_rent==1 && this.propertyData.tenant_id!='')? 2: 1
        }
        let data_electrict = {
          id: 'e1',
          quantity: this.dataElectrict - this.dataLastElectrict,
          price: this.dataElectrictPrice,
          amount: this.dataElectrictAmount,
          check: false,
          name: "ភ្លើង",
          name_en: "Electricity",
          monthBilling: 0,
          old_record: this.dataLastElectrict,
          new_record: this.dataElectrict,
          service_for: (this.propertyData.is_rent==1 && this.propertyData.tenant_id!='')? 2: 1
        }
        list.push(data_watter);
        list.push(data_electrict);

      let dataSubmit = {
          invoice_type: 1,
          project_id: this.dataProjectId,
          property_id: this.dataPropertyId,
          invoice_date: this.dataInvoiceDate,
          expired_date: this.dataInvoiceExpiredDate,
          start_date: this.dataUtilityStartDate,
          end_date: this.dataUtilityEndDate,
          watter: {
            old: this.dataLastWatter,
            current: this.dataWatter,
            price: this.dataWatterPrice,
            amount: this.dataWatterAmount
          },
          electrict: {
            old: this.dataLastElectrict,
            current: this.dataElectrict,
            price: this.dataElectrictPrice,
            amount: this.dataElectrictAmount
          },
          services: list
         
        };





        propertyUtility.insert(dataSubmit)
         .then(response => {
           this.tryingToSubmit = false;
            // console.log(response);
           if(response.status == 200) {
              this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.ok'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-invoice-payment",
                  params:  {id: response.data.id},
                });
                // console.log(response.data.id);
              }
            });
           }
          
        });
    
    },

    clearForm: function() {

      this.dataProperty = 0;

    },

    confirmInvalid: function(){
      this.$swal.fire({
        title: i18n.t('general.invalid.title'),
        text: 'គីឡូទឹកថ្មី មិនអាចតូចជាគីឡូចាស់',
        icon: "warning",
        confirmButtonColor: "#34c38f",
        confirmButtonText: i18n.t('general.ok'),
      }).then(result => {
        if (result.value) {
          this.dataWatter = 0;
          return false;
        } 
      });
    },

    projectChanged: function(event) {
      this.project = event;
      if(this.dataLastProject != 0) {
        this.loadingPropertyData(this.project);
      }
      this.dataLastProject = event;
    },

    formatCurrency(value) {
      if(value == 0 ){
        return 0;
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },

    propertyChanged: function(property) {
      this.loadingPropertyById(property.id);      
    },


    watterChanged: function(){
      if(this.dataWatter > this.dataLastWatter){
        this.dataWatterAmount = ((this.dataWatter - this.dataLastWatter) * this.dataWatterPrice)
      }else{
        this.dataWatterAmount = 0;
      }
    },

    electrictChanged: function(){
      if(this.dataElectrict > this.dataLastElectrict){
        this.dataElectrictAmount = ((this.dataElectrict - this.dataLastElectrict) * this.dataElectrictPrice)
      }else{
        this.dataElectrictAmount = 0;
      }
    }

  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader :items="[{
        text: $t('property.text'),
        href: '/manage/property',
      }, {
        text: $t('manage.wattert-and-electrict-record'),
        active: true
      }]" :title="$t('manage.wattert-and-electrict-record')" />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!-- <div class="col-md-3"> -->
                <!-- <Input 
                  :type="'text'"
                  :id="'property_id'"
                  v-model="propertyData.code"
                  :require="true"
                  :editable="false"
                  :label="'property.text'"  />
              </div> -->
              
               <!-- <div class="col-md-3">
                <Input 
                  :type="'date'"
                  :id="'invoice_date'"
                  v-model="dataInvoiceDate"
                  :require="true"
                  :label="'invoice.date'"  />
              </div>
              <div class="col-md-3">
                <label>{{$t('invoice.price')+$t('invoice.total')}}</label>
                <Input 
                  :type="'number'"
                  :id="'total_price'"
                  v-model="dataTotalPrice"
                  :disabled="true"
                  />
              </div>
              <div class="col-sm-3">
                <Input 
                  :type="'number'"
                  :id="'discount'"
                  v-model="dataDiscount"
                  :last="this.discountText"
                  :label="'booking.discount'"  />
              </div>
              <div class="col-sm-3">
                <Select
                  :id="'discount_type'"
                  :text="'name'"
                  :auto="true"
                  v-model="dataDiscountType"
                  :list="this.discountTypeData"
                  @change="discountTypeChanged" 
                  :label="'booking.as'"
                />
              </div> -->
              <!-- <div class="col-md-3">
                <Select
                  :id="'project_id'"
                  :disabled="true"
                  v-model="dataProjectId"
                  :list="this.projectData"
                  :label="'property.project'"
                  :require="true"
                    /> 
              </div> -->
              
              
              
            </div>
            <div class="row">
              <div class="col-sm-3">
                <Input 
                  :type="'date'"
                  :id="'invoice_date'"
                  v-model="dataInvoiceDate"
                  :require="true"
                  :label="'invoice.date'"  />
              </div>
              <div class="col-sm-3">
                <Input 
                  :type="'date'"
                  :id="'expired_date'"
                  v-model="dataInvoiceExpiredDate"
                  :require="true"
                  :label="'booking.expired'"  />
              </div>
              <div class="col-sm-3">
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="dataUtilityStartDate"
                  :require="true"
                  :label="'manage.utility.start-date'"  />
              </div>
              <div class="col-sm-3">
                <Input 
                  :type="'date'"
                  :id="'end_date'"
                  v-model="dataUtilityEndDate"
                  :require="true"
                  :label="'manage.utility.end-date'"  />
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <p class="khb border-bottom">{{$t('manage.utility.text')}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <Input 
                  :type="'number'"
                  :id="'last_watter'"
                  v-model="dataLastWatter"
                  :require="true"
                  :editable="false"
                  :label="'manage.last-month-watter-record'"  />
              </div>
              <div class="col-md-3">
                <Input 
                  @input="watterChanged()"
                  :type="'number'"
                  :id="'current_watter'"
                  v-model="dataWatter"
                  :require="true"
                  :label="'manage.current-month-watter-record'"  />
              </div>
              <div class="col-md-3">
                <label>{{$t('invoice.price')}} / M <sup>3</sup></label>
                <Input 
                  @input="watterChanged()"
                  :type="'number'"
                  :id="'watter_price'"
                  v-model="dataWatterPrice"
                  :require="true"
                   />
              </div>
              <div class="col-md-3">
                <Input 
                  :type="'number'"
                  :id="'watter_amount'"
                  v-model="dataWatterAmount"
                  :disabled="true"
                  :label="'expense.amount'"  />
              </div>
              
            </div>
             <div class="row">
              <div class="col-sm-3">
                <Input 
                  :type="'number'"
                  :id="'last_electrict'"
                  v-model="dataLastElectrict"
                  :require="true"
                  :editable="false"
                  :label="'manage.last-month-electrict-record'"  />
              </div>
              <div class="col-sm-3">
                <Input 
                  @input="electrictChanged()"
                  :type="'number'"
                  :id="'current_electrict'"
                  v-model="dataElectrict"
                  :require="true"
                  :label="'manage.current-month-electrict-record'"  />
              </div>
              <div class="col-sm-3">
                <label>{{$t('invoice.price')}} / KWH</label>
                <Input 
                  @input="electrictChanged()"
                  :type="'number'"
                  :id="'electrict_price'"
                  v-model="dataElectrictPrice"
                  :require="true"
                  />
              </div>
              <div class="col-sm-3">
                <Input 
                  :type="'number'"
                  :id="'electrict_amount'"
                  :disabled="true"
                  v-model="dataElectrictAmount"
                  :label="'expense.amount'"  />
              </div>
            </div>

            <!-- <div class="row pt-3">
              <div class="col">
                <p class="khb border-bottom">{{$t('manage.service.text')}}</p>
              </div>
            </div> -->

            <!-- <div class="row ">
              <div class="col-sm">
                <div class="row border-top pt-3 bg-light">
                  <div class="col-sm">
                    <p class="">Selected</p>
                  </div>
                  <div class="col-sm-3">
                    <p class="">{{$t('manage.service.name')}}{{$t('manage.service.text')}}</p>
                  </div>
                  <div class="col-sm-2">
                    <p class="">{{$t('manage.billing_cycle_date')}}({{$t('manage.yearly')}})</p>
                  </div>
                  <div class="col-sm-2">
                     <p class="">{{$t('invoice.quantity')}}</p>
                  </div>
                  <div class="col-sm-2">
                    <p class="">{{$t('invoice.price')}}</p>
                  </div>
                  <div class="col-sm-2">
                    <p class="">{{$t('invoice.total')}}</p>
                  </div>
                </div>
                <ServiceRow v-for="(item, index) in modifiedServiceData" :key="index" :ref="'service_' + index"
                  :item="item"
                  :index="index+1"
                />
              </div>
            </div> -->
   
            <br>
            <div class="row">
              <div class="col-lg-12">

                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>